<script>
	import Avatar from "../../../library/Avatar.svelte";
	import Icon from "../../../library/Icon.svelte";

	export let item;

	$: label = item.label;
	$: icon = item.icon;
	$: color = item.color;
	$: avatar = item.avatar;
	$: checked = item.checked;
	$: clickable = item.clickable;

</script>

<div
	class="wx-todo_user-item"
	class:wx-todo_user-item--checked={checked}
	class:wx-todo_user-item--clickable={clickable}>
	{#if icon}
		<Icon name={icon} />
	{/if}
	<div class="wx-todo_user-item__avatar">
		<Avatar {avatar} {color} />
	</div>
	<div class="wx-todo_user-item__label">{label}</div>
</div>

<style>
	.wx-todo_user-item {
		cursor: default;

		width: 100%;
		min-width: 200px;
		max-height: 36px;

		cursor: pointer;
		display: flex;
		align-items: center;
		justify-content: flex-start;

		padding: 8px;

		font-family: var(--wx-font-family);
		font-size: var(--wx-font-size);
		line-height: var(--wx-line-height);

		color: var(--wx-color-font);
	}
	.wx-todo_user-item:hover,
	.wx-todo_user-item--checked {
		cursor: pointer;
		background: var(--wx-background-selected);
	}
	.wx-todo_user-item__label {
		padding: 0 8px;
	}
	.wx-todo_user-item__avatar {
		padding-left: 6px;
	}

</style>
